import * as $ from "jquery";
import {MapEvent} from "./Types";
import {Format} from "./Format";
import {MapView} from "./MapView";

/** Spisak termina za trenutni filter, grupisan po mestu/opštini. */
export class ListPanel {

    public static render(events: MapEvent[]): void {
        const body = $('#listBody').empty();
        $('#listCount').text(events.length);
        if (events.length === 0) {
            body.append('<div class="list-group-item text-muted">Нема термина за изабрани дан.</div>');
            return;
        }
        const groups: Record<string, MapEvent[]> = {};
        events.forEach(ev => {
            const key = ev.pointMunicipality || ev.place || 'Остало';
            (groups[key] = groups[key] || []).push(ev);
        });
        Object.keys(groups).sort((a, b) => a.localeCompare(b, 'sr')).forEach(key => {
            body.append($('<div class="list-group-item group-head"></div>').text(key));
            groups[key]
                .sort((a, b) => new Date(a.eventTime).getTime() - new Date(b.eventTime).getTime())
                .forEach(ev => {
                    const item = $('<a class="list-group-item list-group-item-action"></a>');
                    item.append($('<div class="fw-semibold"></div>').text(ev.title));
                    item.append($('<div class="small"></div>').text(Format.placeLine(ev)));
                    item.append($('<div class="small text-muted"></div>').text(Format.schedule(ev)));
                    item.on('click', () => {
                        MapView.focus(ev.latitude, ev.longitude);
                        MapView.showEvent(ev);
                    });
                    body.append(item);
                });
        });
    }

    public static setTitle(title: string): void {
        $('#listTitle').text(title);
    }
}
